module.exports = __webpack_public_path__ + "img/home-newsletter-bg.4b53cfd6.webp";